// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled, { css } from 'styled-components';
import type { LinkProps } from '@helpcenter/analytics-components/src/link';
import { Link } from '@helpcenter/analytics-components/src/link';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css, @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const style = css<LinkProps & { hasUnderline?: boolean }>`
	color: ${(props) => token('color.link', props.theme.color)};
	${(props) => props.hasUnderline && 'text-decoration: underline;'}

	&:hover {
		color: ${(props) => token('color.link', props.theme.color)};
	}
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ThemedLink = styled(Link)<{ hasUnderline?: boolean }>`
	${style};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export default ThemedLink;
